import React, { useState } from 'react';
import { Card, Row, Col, Table, Nav } from 'react-bootstrap';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';
import './IncomeDashboard.scss';

const IncomeDashboard = () => {
  const [key, setKey] = useState('monthly');

  // Monthly income data
  const monthlyData = [
    { id: 1, month: 'January', sales: 450000, rent: 15000, total: 465000 },
    { id: 2, month: 'February', sales: 350000, rent: 18000, total: 368000 },
    { id: 3, month: 'March', sales: 550000, rent: 20000, total: 570000 },
    { id: 4, month: 'April', sales: 480000, rent: 22000, total: 502000 },
  ];

  // Annual income data
  const annualData = [
    { id: 1, year: '2023', sales: 5200000, rent: 240000, total: 5440000 },
    { id: 2, year: '2024', sales: 5800000, rent: 280000, total: 6080000 },
    { id: 3, year: '2025', sales: 1830000, rent: 75000, total: 1905000 },
  ];

  return (
    <div className="income-dashboard">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="page-title">Income Management</h2>
      </div>

      <Nav variant="tabs" activeKey={key} onSelect={(k) => setKey(k)}>
        <Nav.Item>
          <Nav.Link eventKey="monthly">Monthly Income</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="annual">Annual Income</Nav.Link>
        </Nav.Item>
      </Nav>

      <Card className="income-table-card mt-4">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <Card.Title>{key === 'monthly' ? 'Monthly Income Overview' : 'Annual Income Overview'}</Card.Title>
            <div className="summary-badge">
              Total: ${(key === 'monthly' ? monthlyData : annualData)
                .reduce((sum, item) => sum + item.total, 0)
                .toLocaleString()}
            </div>
          </div>
          <Table responsive>
            <thead>
              <tr>
                <th>{key === 'monthly' ? 'Month' : 'Year'}</th>
                <th>Sales Income</th>
                <th>Rental Income</th>
                <th>Total</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {(key === 'monthly' ? monthlyData : annualData).map((item) => (
                <tr key={item.id}>
                  <td>{key === 'monthly' ? item.month : item.year}</td>
                  <td>${item.sales.toLocaleString()}</td>
                  <td>${item.rent.toLocaleString()}</td>
                  <td className="total-column">${item.total.toLocaleString()}</td>
                  <td>
                    <div className="action-buttons">
                      <button className="btn btn-info btn-sm">
                        <FaEye />
                      </button>
                      <button className="btn btn-primary btn-sm">
                        <FaEdit />
                      </button>
                      <button className="btn btn-danger btn-sm">
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </div>
  );
};

export default IncomeDashboard;
